export enum paymentMethods {
  AMERICANEXPRESS = "AMERICANEXPRESS",
  AMEX = "AMEX",
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  MAESTRO = "MAESTRO",
  APPLEPAY = "APPLEPAY",
  ANDROIDPAY = "ANDROIDPAY",
  ONE4ALL_VOUCHER = "ONE4ALL_VOUCHER",
  ME2YOU_VOUCHER = "ME2YOU_VOUCHER",
  CASH = "CASH",
  AFTERPAY = "AFTERPAY",
  ALIPAY = "ALIPAY",
  BACS = "BACS",
  BITCOIN = "BITCOIN",
  CHECK = "CHECK",
  CONTACTLESSPAYME = "CONTACTLESSPAYME",
  DINERSCLUB = "DINERSCLUB",
  DIRECTDEBIT = "DIRECTDEBIT",
  DISCOVER = "DISCOVER",
  FINANCING = "FINANCING",
  INVOICE = "INVOICE",
  KLARNA = "KLARNA",
  PAYPAL = "PAYPAL",
  TRAVELERSCHECK = "TRAVELERSCHECK",
  UNIONPAY = "UNIONPAY",
  VPAY = "VPAY",
  WECHATPAY = "WECHATPAY",
}

export const paymentMethodsWithVisualizationSupport: Record<string, true> = {
  [paymentMethods.AMERICANEXPRESS]: true,
  [paymentMethods.AMEX]: true,
  [paymentMethods.VISA]: true,
  [paymentMethods.MASTERCARD]: true,
  [paymentMethods.MAESTRO]: true,
  [paymentMethods.APPLEPAY]: true,
  [paymentMethods.ANDROIDPAY]: true,
  [paymentMethods.ONE4ALL_VOUCHER]: true,
  [paymentMethods.ME2YOU_VOUCHER]: true,
  [paymentMethods.CASH]: true,
};

export const paymentMethodCodeToNameMap: Record<string, string> = {
  [paymentMethods.AMERICANEXPRESS]: "American Express",
  [paymentMethods.AMEX]: "American Express",
  [paymentMethods.VISA]: "Visa",
  [paymentMethods.MASTERCARD]: "MasterCard",
  [paymentMethods.MAESTRO]: "Maestro",
  [paymentMethods.APPLEPAY]: "Apple Pay",
  [paymentMethods.ANDROIDPAY]: "Google Pay",
  [paymentMethods.ONE4ALL_VOUCHER]: "One4all",
  [paymentMethods.ME2YOU_VOUCHER]: "Me2You",
  [paymentMethods.CASH]: "Cash",
  [paymentMethods.AFTERPAY]: "Afterpay",
  [paymentMethods.ALIPAY]: "Alipay",
  [paymentMethods.BACS]: "BACS",
  [paymentMethods.BITCOIN]: "Bitcoin",
  [paymentMethods.CHECK]: "Check",
  [paymentMethods.CONTACTLESSPAYME]: "Contactless Payment",
  [paymentMethods.DINERSCLUB]: "Diners Club",
  [paymentMethods.DIRECTDEBIT]: "Direct Debit",
  [paymentMethods.DISCOVER]: "Discover",
  [paymentMethods.FINANCING]: "Financing",
  [paymentMethods.INVOICE]: "Invoice",
  [paymentMethods.KLARNA]: "Klarna",
  [paymentMethods.PAYPAL]: "PayPal",
  [paymentMethods.TRAVELERSCHECK]: "Traveller's Cheque",
  [paymentMethods.UNIONPAY]: "China UnionPay",
  [paymentMethods.VPAY]: "V PAY",
  [paymentMethods.WECHATPAY]: "WeChat Pay",
};
